export const StatoRichiestaMutuo = {
    creata :'Creata',
    inoltrata: 'Inoltrata',
    rifiutata: 'Rifiutata',
    accettata: 'Accettata'
};



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/stato-richiesta-mutuo.ts